import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { accentColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledRecommendedPathWrapper = styled.div`
  transform: scale(1);
  width: 100%;
  &:before {
    content: 'Recommended for you';
    position: absolute;
    white-space: nowrap;
    border-top-left-radius: ${({ theme }) => theme.radius.small};
    border-top-right-radius: ${({ theme }) => theme.radius.small};
    top: -2.2rem;
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    background: ${({ theme }) => theme.colors.primary.main};
    left: 50%;
    transform: translate(-50%, 0);
    padding: 0.2rem 1.6rem;
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const StyledRecommendedPath = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  border: 2px solid ${({ theme }) => theme.colors.primary.main};
  border-radius: ${({ theme }) => theme.radius.small};
  overflow: hidden;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 2.2rem;
  }
`;

export const StyledRecommendedPathHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: stretch;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
  }
`;

export const StyledRecommendedPathHeaderLeftSection = styled.div`
  display: flex;
  background: rgba(28, 37, 56, 1);
  flex: 1;
  flex-direction: column;
  padding: 2.4rem;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 1.8rem;
  }
`;

export const StyledRecommendedPathTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.grey[100]};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: 2rem;
  margin-bottom: 1rem;
`;

export const StyledRecommendedPathSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.grey[200]};
  line-height: normal;
  margin-bottom: 2.4rem;
  * :not(:first-child) {
    display: none;
  }
`;

export const StyledRecommendedPathImageWrapper = styled.div`
  position: relative;
  max-width: 26rem;
  min-height: 14.5rem;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90.46deg, #1c2538 0.4%, rgba(28, 37, 56, 0) 50%);
    pointer-events: none;
    z-index: 1;
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    max-width: 100%;
    min-height: 15rem;

    &::after {
      background: linear-gradient(180deg, #1c2538 0.4%, rgba(28, 37, 56, 0) 50%);
    }
  }
`;

export const StyledRecommendedPathImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  display: block;
`;

export const StyledPathAttribute = styled.span`
  color: ${({ theme }) => theme.colors.grey[400]};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  display: flex;
  align-items: center;
  font-size: 1.6rem;
  gap: 0.6rem;
`;

export const StyledPathSection = styled.div`
  width: 100%;
  :not(:last-child) {
    margin-bottom: 2.4rem;
  }

  h4 {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    color: ${({ theme }) => theme.colors.grey[500]};
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    margin-bottom: 0.8rem;
  }
  p {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    color: ${({ theme }) => theme.colors.grey[100]};
    font-size: 2rem;
    margin-bottom: 0.8rem;
  }
`;

export const StyledPathSectionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.1rem solid rgba(62, 71, 90, 1);
  color: ${({ theme }) => theme.colors.grey[100]};
  padding: 0.8rem 0 0.8rem 0;
  margin-right: 1.6rem;
`;

export const StyledPathSectionItemImageAndTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  img {
    max-width: 3.6rem;
  }
`;

export const StyledCompletedRoomIcon = styled(FontAwesomeIcon)`
  color: ${accentColors.success.dark};
  width: 2rem;
  height: 2rem;
`;

export const ProgressBarAndLabelWrapper = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
`;

export const ProgressBarWrapper = styled.div`
  width: 6.5rem;
`;

export const ProgressBarLabel = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export const StyledPathSections = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.4rem;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 1.8rem;
  }
  background: ${({ theme }) => theme.colors.secondary.light};
`;

export const StyledTitle = styled.h1`
  color: ${({ theme }) => theme.colors.text.main};
  font-size: 3.2rem;
  text-align: center;
  margin-bottom: 1.8rem;
  margin-top: 6.4rem;
  line-height: 3.67rem;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 3.5rem;
  }
`;

export const StyledModulesWrapper = styled.div`
  height: 28rem;
  overflow-y: auto;
  ::-webkit-scrollbar-thumb {
    background-color: rgb(114, 124, 146);
    border-radius: 1rem;
  }
  ::-webkit-scrollbar-track {
    background-color: rgb(82, 90, 106);
    border-radius: 1rem;
  }
`;

export const StyledRoadmapHeader = styled.div`
  width: 100%;
  background: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.6rem;
  padding-bottom: 3rem;
`;

export const StyledRoadmapWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 2.2rem;
  }
`;
